import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@environments/environment';
import { AuthenticationService } from '@app/services/authentication.service';
import { NgxSpinnerService } from 'ngx-spinner';


@Injectable()
export class JwtInterceptor implements HttpInterceptor {
   // spinner: any;
    constructor(private authenticationService: AuthenticationService,private spinner: NgxSpinnerService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
       // debugger;
        // add auth header with jwt if user is logged in and request is to api url
        // this.spinner.show();

        const currentUser = JSON.parse(localStorage.getItem('currentUser'));
        const isLoggedIn = currentUser && currentUser.accessToken;
        const isApiUrl = request.url.startsWith(environment.apiUrl);
        if (isLoggedIn && isApiUrl) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${currentUser.accessToken}`,
                    'Access-Control-Allow-Origin': '*'
                }
            });
        }

        return next.handle(request);
    }
}